import { SubcategoryDetailProps } from "../constants/settingsStructure";
import LegacySettingsRedirect from "../components/LegacySettingsRedirect";

const StatusDetail = ({ subcategory, categoryId }: SubcategoryDetailProps) => {
  return (
    <LegacySettingsRedirect
      title={subcategory.label}
      description="Configure status options to track progress and states."
      categoryId={categoryId}
    />
  );
};

export default StatusDetail;
